export default __webpack_public_path__ + "static/media/laraL.4aa1ba7a.png";